import { render, staticRenderFns } from "./CTableHeadCell.vue?vue&type=template&id=344df762&scoped=true&"
import script from "./CTableHeadCell.vue?vue&type=script&lang=ts&"
export * from "./CTableHeadCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344df762",
  null
  
)

export default component.exports